import { createFeatureSelector, createSelector } from '@ngrx/store';
import { GET_RECEIPT_STORE_NAME, GetReceiptState } from './get-receipt.state';

/** Select GetReceipt State */
export const selectGetReceiptState = createFeatureSelector<GetReceiptState>(GET_RECEIPT_STORE_NAME);

/** Select GetReceipt isPending status */
export const selectGetReceiptIsPendingStatus = createSelector(selectGetReceiptState, (state) => !!state.isPending);

/** Select GetReceipt isFailure status */
export const selectGetReceiptIsFailureStatus = createSelector(selectGetReceiptState, (state) => !!state.isFailure);
